// import React from "react";

// const partners = [
//   { id: 1, name: "Partner 1", logo: "/logos/airline-1.svg" },
//   { id: 2, name: "Turkish Airlines", logo: "/logos/turkish.svg" },
//   { id: 3, name: "Saudia", logo: "/logos/saudia.svg" },
//   { id: 4, name: "British Airways", logo: "/logos/british-airways.svg" },
//   { id: 5, name: "Partner 5", logo: "/logos/airline-5.svg" },
//   { id: 6, name: "Singapore Airlines", logo: "/logos/singapore.svg" },
//   { id: 7, name: "Lufthansa", logo: "/logos/lufthansa.svg" },
//   { id: 8, name: "Partner 8", logo: "/logos/airline-8.svg" },
//   { id: 9, name: "Air India", logo: "/logos/air-india.svg" },
//   { id: 10, name: "Malaysia Airlines", logo: "/logos/malaysia.svg" },
//   { id: 11, name: "Qatar Airways", logo: "/logos/qatar.svg" },
//   { id: 12, name: "Delta", logo: "/logos/delta.svg" },
// ];

// const FeaturedPartners = () => {
//   return (
//     <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 py-12 font-sans">
//       <div className="relative">
//         {/* Overlapping Badge */}
//         <div className="absolute -top-3.5 left-4 sm:left-8 bg-white border border-slate-200 text-slate-800 text-[10px] sm:text-[11px] font-bold tracking-wider px-4 sm:px-5 py-1.5 rounded-full shadow-sm z-10 uppercase">
//           Featured Partners
//         </div>

//         {/* Gradient Container */}
//         <div className="bg-gradient-to-r from-[#faf5f6] via-[#f0f4fc] to-[#faf5f6] rounded-2xl sm:rounded-3xl border border-slate-200/80 shadow-[0_8px_30px_rgb(0,0,0,0.03)] px-6 py-10 sm:px-10 lg:px-12">
//           {/*
//             Responsive Grid System:
//             - Default (Mobile): 4 columns (grid-cols-4)
//             - Medium (Tablet): 6 columns (md:grid-cols-6)
//             - Extra Large (Desktop): 12 columns (xl:grid-cols-12)
//           */}
//           <div className="grid grid-cols-4 md:grid-cols-6 xl:grid-cols-12 gap-x-4 gap-y-8 sm:gap-y-10 items-center justify-items-center">
//             {partners.map((partner) => (
//               <div
//                 key={partner.id}
//                 className="flex items-center justify-center w-full h-10 sm:h-12 lg:h-14 transition-transform hover:scale-105 duration-300 cursor-pointer"
//               >
//                 {/*
//                   Note: Replace the src below with your actual image paths.
//                   Using a placeholder fallback here for visual structure.
//                 */}
//                 <img
//                   src={partner.logo}
//                   alt={partner.name}
//                   className="max-h-full max-w-[85%] object-contain"
//                   onError={(e) => {
//                     // Fallback if local logos aren't added yet
//                     e.target.onerror = null;
//                     e.target.src = `https://placehold.co/120x60/transparent/475569?text=Logo+${partner.id}`;
//                   }}
//                 />
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default FeaturedPartners;
import React from "react";

// Import SVGs from your src/assets directory
import WY from "../../assets/airlines/WY.svg";
import TK from "../../assets/airlines/TK.svg";
import SV from "../../assets/airlines/SV.svg";
import BA from "../../assets/airlines/BA.svg";
import PK from "../../assets/airlines/PK.svg";
import SQ from "../../assets/airlines/SQ.svg";
import LH from "../../assets/airlines/LH.svg";
import AF from "../../assets/airlines/AF.svg";
import AI from "../../assets/airlines/AI.svg";
import MH from "../../assets/airlines/MH.svg";
import QR from "../../assets/airlines/QR.svg";
import DL from "../../assets/airlines/DL.svg";

// Map the imported SVGs to the partners array
const partners = [
  { id: 1, name: "Oman Air", logo: WY },
  { id: 2, name: "Turkish Airlines", logo: TK },
  { id: 3, name: "Saudia", logo: SV },
  { id: 4, name: "British Airways", logo: BA },
  { id: 5, name: "PIA", logo: PK },
  { id: 6, name: "Singapore Airlines", logo: SQ },
  { id: 7, name: "Lufthansa", logo: LH },
  { id: 8, name: "Airline Partner", logo: AF },
  { id: 9, name: "Air India", logo: AI },
  { id: 10, name: "Malaysia Airlines", logo: MH },
  { id: 11, name: "Qatar Airways", logo: QR },
  { id: 12, name: "Delta", logo: DL },
];

const FeaturedPartners = () => {
  return (
    <div className="w-full max-w-[1400px] mx-auto px-4 sm:px-6 py-12 font-sans">
      <div className="relative">
        {/* Overlapping Badge */}
        <div className="absolute -top-3.5 left-4 sm:left-8 bg-white border border-slate-200 text-slate-800 text-[10px] sm:text-[11px] font-bold tracking-wider px-4 sm:px-5 py-1.5 rounded-full shadow-sm z-10 uppercase">
          Featured Partners
        </div>

        {/* Gradient Container */}
        <div className="bg-gradient-to-r from-[#faf5f6] via-[#f0f4fc] to-[#faf5f6] rounded-2xl sm:rounded-3xl border border-slate-200/80 shadow-[0_8px_30px_rgb(0,0,0,0.03)] px-6 py-10 sm:px-10 lg:px-12">
          {/* 
            Responsive Grid System:
            - Default (Mobile): 4 columns 
            - Medium (Tablet): 6 columns 
            - Extra Large (Desktop): 12 columns 
          */}
          <div className="grid grid-cols-4 md:grid-cols-6 xl:grid-cols-12 gap-x-4 gap-y-8 sm:gap-y-10 items-center justify-items-center">
            {partners.map((partner) => (
              <div
                key={partner.id}
                className="flex items-center justify-center w-full h-10 sm:h-12 lg:h-14 transition-transform hover:scale-105 duration-300 cursor-pointer"
              >
                <img
                  src={partner.logo}
                  alt={partner.name}
                  className="max-h-full max-w-[85%] object-contain drop-shadow-sm text-xs font-semibold text-slate-700"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturedPartners;
